<div :class="[foundryDD]">
  <FouDropdown
    :options="foundry.options"
    :default-value="foundry.values"
    :placeholder="'Select a foundry'"
    :selectAction="updateFoundryValues"
    :customClass="[inputFont, inputWidth]" 
    :errorClass="[errorCSS]"
    smallPlaceHolder="Foundry"
    rules="required"
    name="Foundry"
  />
</div>